export default "__VITE_ASSET__BBeOvXVW__"